// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"132":"reception","509":"tickets","596":"404"}[chunkId] || chunkId) + "." + {"132":"927c662d","475":"6a5615cc","509":"8c209163","555":"5080d424","573":"4d77f7c3","596":"41dc39db","724":"c6270fc4"}[chunkId] + ".css";
};